import React from "react";
import { useParams } from "react-router-dom";
import styles from "../styles/cacerias.module.css";
import { IoTrashOutline, IoPencilOutline, IoWarningOutline, IoCopyOutline, IoLinkOutline, IoAddOutline } from "react-icons/io5";
import ConfirmDeleteModal from "../../../components/ConfirmDeleteModal";
import InfoModal from "../../../components/InfoModal";
import { FaMagnifyingGlass } from "react-icons/fa6";

import { formatDate } from "../domain/caceriasFormat";
import { getCaceriaAssociations } from "../domain/caceriasAssociations";
import { getRolNameById } from "../domain/caceriasRules";
import { useCacerias } from "../hooks/useCacerias";
import { ArmaSearchSelect } from "../../eventos/components/ArmaSearchSelect";

export default function Cacerias() {
  const { id: caceriaIdFromRoute } = useParams();
  const {
    personas,
    roles,
    armas,
    tipoCaceria,
    eventos,
    armasIndex,

    q,
    setQ,
    selectedYear,
    setSelectedYear,
    estadoTiempo,
    setEstadoTiempo,
    toggleOpen,
    isOpen,

    isAddOpen,
    setIsAddOpen,
    isEditOpen,
    setIsEditOpen,

    showDeleteConfirmation,
    caceriaToDelete,
    infoModal,
    setInfoModal,

    newCaceriaData,
    caceriaToEdit,
    fileNew,
    setFileNew,
    fileEdit,
    setFileEdit,

    years,
    list,
    kpiTotal,
    kpiConAlerta,
    kpiParticipantes,
    caceriaEventoMap,

    armaLabel,
    personasFiltradasParaIndex,

    handleNewCaceriaChange,
    handleAddParticipationField,
    handleRemoveParticipationField,
    handleParticipationChange,
    handleAddEnlace,
    handleRemoveEnlace,
    handleEnlaceChange,
    handleSubmitNewCaceria,

    handleEditCaceria,
    handleEditCaceriaChange,
    handleAddParticipationFieldEdit,
    handleRemoveParticipationFieldEdit,
    handleParticipationChangeEdit,
    handleAddEnlaceEdit,
    handleRemoveEnlaceEdit,
    handleEnlaceChangeEdit,
    handleSubmitEditCaceria,

    handleDeleteCaceria,
    confirmDeleteCaceria,
    handleDuplicateCaceria,
  } = useCacerias(caceriaIdFromRoute);

  return (
    <div className={styles.page}>
      <div className={`${styles.wrap} ${styles.stack}`}>
        <div className={styles.titlebar}>
          <h2>Cacerías</h2>
        </div>

        <div className={styles["estado-tabs"]} style={{ display: "flex", gap: 8, marginBottom: 10 }}>
          <button
            type="button"
            onClick={() => setEstadoTiempo("pendientes")}
            style={{
              padding: "6px 14px",
              borderRadius: 999,
              border: "1px solid #ccc",
              background: estadoTiempo === "pendientes" ? "#455E1D" : "#fff",
              color: estadoTiempo === "pendientes" ? "#fff" : "#333",
              cursor: "pointer",
            }}
          >
            Pendientes
          </button>
          <button
            type="button"
            onClick={() => setEstadoTiempo("pasados")}
            style={{
              padding: "6px 14px",
              borderRadius: 999,
              border: "1px solid #ccc",
              background: estadoTiempo === "pasados" ? "#455E1D" : "#fff",
              color: estadoTiempo === "pasados" ? "#fff" : "#333",
              cursor: "pointer",
            }}
          >
            Pasadas
          </button>
        </div>

        <div className={`${styles.card} ${styles["filters-row"]}`}>
          <input
            className={styles.input}
            placeholder="Buscar por fecha, tipo o participante…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <select className={styles.input} value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
            {years.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
          <div className={styles.actionsRow}>
            <button type="button" className={`${styles.btn} ${styles.primary}`} onClick={() => setIsAddOpen(true)}>
              + Nueva cacería
            </button>
          </div>
        </div>

        <div className={styles.kpis}>
          <div className={styles.kpi}>
            <span className={styles["kpi-title"]}>Total</span>
            <span className={styles["kpi-value"]}>{kpiTotal}</span>
          </div>
          <div className={styles.kpi}>
            <span className={styles["kpi-title"]}>Con advertencia</span>
            <span className={styles["kpi-value"]}>{kpiConAlerta}</span>
          </div>
          <div className={styles.kpi}>
            <span className={styles["kpi-title"]}>Participaciones</span>
            <span className={styles["kpi-value"]}>{kpiParticipantes}</span>
          </div>
        </div>

        <section className={styles.section}>
          <div className={styles.stack}>
            {list.length === 0 ? (
              <div className={`${styles.card} ${styles.soft} ${styles.empty}`}>
                <h4 style={{ margin: 0 }}><FaMagnifyingGlass style={{ fontSize: "30px" }} /></h4>
                <p className={styles.muted}>Prueba con otro término de búsqueda o crea una cacería.</p>
              </div>
            ) : (
              list.map((c) => {
                const open = isOpen(c.id);
                const { hunters } = getCaceriaAssociations(c);

                const evFromCaceria = c.evento || (c.eventoId && eventos.find((e) => e.id === c.eventoId));
                const evInfo = evFromCaceria || caceriaEventoMap.get(c.id) || null;

                const resumen = [
                  c.tipoCaceria || "—",
                  hunters.length ? `${hunters.length} cazador(es)` : "Sin cazadores",
                ].filter(Boolean).join(" • ");

                return (
                  <article key={c.id} className={`${styles["item-card"]} ${styles.accordion} ${open ? styles.open : ""}`}>
                    <button
                      type="button"
                      className={styles["accordion-header"]}
                      onClick={() => toggleOpen(c.id)}
                      aria-expanded={open}
                      aria-controls={`caceria-body-${c.id}`}
                    >
                      <div className={styles["accordion-title"]}>
                        <strong>{c.nombre ? c.nombre : formatDate(c.fecha)}</strong>
                        <span className={styles.muted}>
                          {c.nombre ? ` (${formatDate(c.fecha)}) — ${resumen}` : `— ${resumen}`}
                        </span>

                        {evInfo && (
                          <span className={`${styles.pill} ${styles.ghost}`} style={{ marginLeft: 8 }}>
                            Evento: <strong>{evInfo.nombre}</strong>
                            {evInfo.fechaInicio && evInfo.fechaFin ? (
                              <> — {formatDate(evInfo.fechaInicio)} - {formatDate(evInfo.fechaFin)}</>
                            ) : null}
                          </span>
                        )}

                        {c.tieneAdvertencia && (
                          <span className={`${styles.pill} ${styles.danger}`} title="Algún participante tiene documentación caducada">
                            <IoWarningOutline /> Alerta
                          </span>
                        )}
                      </div>
                      <span className={styles.chevron} aria-hidden>▾</span>
                    </button>

                    <div id={`caceria-body-${c.id}`} className={styles["accordion-body"]}>
                      <div className={styles["item-row"]}>
                        {hunters.length === 0 ? (
                          <div className={styles["empty-inline"]}>Sin participantes.</div>
                        ) : (
                          <div className={styles["responsive-table"]}>
                            <table>
                              <thead>
                                <tr>
                                  <th>Participante</th>
                                  <th>Arma1</th>
                                  <th>Arma2</th>
                                  <th>Secretario</th>
                                  <th>Cargador</th>
                                </tr>
                              </thead>
                              <tbody>
                                {hunters.map(({ hunter, arma1, arma2, secretario, cargador }) => (
                                  <tr key={`h-${hunter?.id}`}>
                                    <td>
                                      <strong>{hunter?.nombre} {hunter?.apellidos}</strong>
                                      {hunter?.tieneAdvertencia && (
                                        <IoWarningOutline className={styles["warn-icon-inline"]} title="Documentación caducada" />
                                      )}
                                    </td>
                                    <td>{armaLabel(arma1)}</td>
                                    <td>{armaLabel(arma2)}</td>
                                    <td>{secretario?.nombre} {secretario?.apellidos}</td>
                                    <td>{cargador?.nombre} {cargador?.apellidos}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                        <div className={styles["item-actions"]}>
                          {c.rutaDocumento && (
                            <div style={{ marginTop: 8 }}>
                              <a href={c.rutaDocumento} target="_blank" rel="noreferrer" className={`${styles.btn} ${styles.ghost}`}>
                                Ver documento
                              </a>
                            </div>
                          )}

                          {c.enlaces?.length > 0 && (
                            <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 6 }}>
                              {c.enlaces.map((url, i) => (
                                <a
                                  key={i}
                                  href={url}
                                  target="_blank"
                                  rel="noreferrer"
                                  className={`${styles.btn} ${styles.ghost}`}
                                  title={url}
                                >
                                  <IoLinkOutline /> Enlace {c.enlaces.length > 1 ? i + 1 : ""}
                                </a>
                              ))}
                            </div>
                          )}

                          <button className={styles.btn} type="button" onClick={() => handleEditCaceria(c)}>
                            <IoPencilOutline /> Editar
                          </button>
                          <button className={styles.btn} type="button" onClick={() => handleDuplicateCaceria(c)}>
                            <IoCopyOutline /> Duplicar
                          </button>
                          <button className={`${styles.btn} ${styles.danger}`} type="button" onClick={() => handleDeleteCaceria(c)}>
                            <IoTrashOutline /> Eliminar
                          </button>
                        </div>

                      </div>
                    </div>
                  </article>
                );
              })
            )}
          </div>
        </section>
      </div>

      {/* MODAL: NUEVA CACERÍA */}
      {isAddOpen && (
        <div className={styles["modal-overlay"]}>
          <div className={`${styles["modal-content"]} ${styles["modal-form"]}`}>
            <form onSubmit={handleSubmitNewCaceria}>
              <h3>Nueva cacería</h3>

              <div className={styles.field}>
                <label className={styles.label}>Nombre (opcional)</label>
                <input
                  type="text"
                  name="nombre"
                  placeholder="Ej: Montería La Dehesa"
                  value={newCaceriaData.nombre || ""}
                  onChange={handleNewCaceriaChange}
                />
              </div>

              <div className={styles["grid-2"]}>
                <div className={styles.field}>
                  <label className={styles.label}>Fecha</label>
                  <input type="date" name="fecha" value={newCaceriaData.fecha} onChange={handleNewCaceriaChange} required />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Tipo de cacería</label>
                  <select name="tipoCaceria" value={newCaceriaData.tipoCaceria} onChange={handleNewCaceriaChange} required>
                    {tipoCaceria.map((t) => {
                      const value = typeof t === "string" ? t : t.codigo ?? t.id ?? t.value ?? t.nombre;
                      const label = typeof t === "string" ? t : t.descripcion ?? t.nombre ?? t.label ?? value;
                      return <option key={value} value={value}>{label}</option>;
                    })}
                  </select>
                </div>
              </div>

              <div className={styles.field} style={{ marginTop: 10 }}>
                <label className={styles.label}>Documento (PDF/Imagen/Excel/CSV)</label>
                <input
                  type="file"
                  accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                  onChange={(e) => setFileNew(e.target.files?.[0] ?? null)}
                />
                {newCaceriaData.rutaDocumento && (
                  <div style={{ marginTop: 8 }}>
                    <a href={newCaceriaData.rutaDocumento} target="_blank" rel="noreferrer">Ver documento actual</a>
                  </div>
                )}
              </div>

              <div className={styles.field} style={{ marginTop: 10 }}>
                <label className={styles.label}>Enlaces (OneDrive, SharePoint…)</label>
                {(newCaceriaData.enlaces || []).map((url, i) => (
                  <div key={i} style={{ display: "flex", gap: 8, marginTop: 6 }}>
                    <input
                      type="url"
                      placeholder="https://..."
                      value={url}
                      onChange={(e) => handleEnlaceChange(i, e.target.value)}
                      style={{ flex: 1 }}
                    />
                    <button type="button" className={`${styles.btn} ${styles.danger}`} onClick={() => handleRemoveEnlace(i)}>
                      <IoTrashOutline />
                    </button>
                  </div>
                ))}
                <button type="button" className={styles.btn} style={{ marginTop: 8 }} onClick={handleAddEnlace}>
                  <IoAddOutline /> Añadir enlace
                </button>
              </div>

              <h4>Cazadores</h4>

              {newCaceriaData.participaciones.length === 0 && (
                <div className={`${styles.card} ${styles.soft}`}>Aún no hay participantes.</div>
              )}

              {newCaceriaData.participaciones.map((p, i) => {
                const personasFiltradas = personasFiltradasParaIndex(newCaceriaData.participaciones, i);

                return (
                  <div key={i} className={styles["item-card"]}>
                    <div className={styles["item-row"]}>
                      <div className={styles["grid-3"]}>
                        <div className={styles.field}>
                          <label className={styles.label}>Rol</label>
                          <select value={p.rol} onChange={(e) => handleParticipationChange(i, "rol", e.target.value)} required>
                            <option value="">Seleccione un rol</option>
                            {roles.map((r) => <option key={r.id} value={r.id}>{r.rol}</option>)}
                          </select>
                        </div>

                        <div className={styles.field}>
                          <label className={styles.label}>Persona</label>
                          <select value={p.persona} onChange={(e) => handleParticipationChange(i, "persona", e.target.value)} required>
                            <option value="">Seleccione una persona</option>
                            {personasFiltradas.map((pp) => (
                              <option key={pp.id} value={pp.id}>{pp.nombre} {pp.apellidos}</option>
                            ))}
                          </select>
                        </div>

                        <div className={styles.field}>
                          <label className={styles.label}>Arma 1</label>
                          <div className={styles.armaField}>
                            <ArmaSearchSelect
                              armas={armasIndex}
                              valueId={p.arma1 || ""}
                              onChange={(newId) => handleParticipationChange(i, "arma1", newId || "")}
                            />
                          </div>
                        </div>

                        <div className={styles.field}>
                          <label className={styles.label}>Arma 2</label>
                          <div className={styles.armaField}>
                            <ArmaSearchSelect
                              armas={armasIndex}
                              valueId={p.arma2 || ""}
                              onChange={(newId) => handleParticipationChange(i, "arma2", newId || "")}
                            />
                          </div>
                        </div>

                      </div>

                      {getRolNameById(roles, p.rol) === "CAZADOR" && (
                        <div className={styles["grid-3"]}>
                          <div className={styles.field}>
                            <label className={styles.label}>Secretario (trabajador)</label>
                            <select value={p.secretarioId || ""} onChange={(e) => handleParticipationChange(i, "secretarioId", e.target.value)}>
                              <option value="">Selecciona secretario</option>
                              {personas.filter((per) => per.tipoPersona === "STAFF").map((per) => (
                                <option key={per.id} value={per.id}>{per.nombre} {per.apellidos}</option>
                              ))}
                            </select>
                          </div>
                          <div className={styles.field}>
                            <label className={styles.label}>Cargador (trabajador)</label>
                            <select value={p.cargadorId || ""} onChange={(e) => handleParticipationChange(i, "cargadorId", e.target.value)}>
                              <option value="">Selecciona cargador</option>
                              {personas.filter((per) => per.tipoPersona === "STAFF").map((per) => (
                                <option key={per.id} value={per.id}>{per.nombre} {per.apellidos}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}

                      <div className={styles["item-actions"]}>
                        <button type="button" className={`${styles.btn} ${styles.danger}`} onClick={() => handleRemoveParticipationField(i)}>
                          <IoTrashOutline /> Eliminar participante
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}

              <div className={styles["item-actions"]}>
                <button type="button" className={styles.btn} onClick={handleAddParticipationField}>
                  + Añadir participante
                </button>
              </div>

              <div className={styles["modal-actions"]}>
                <button type="button" className={`${styles.btn} ${styles.ghost}`} onClick={() => setIsAddOpen(false)}>
                  Cancelar
                </button>
                <button type="submit" className={`${styles.btn} ${styles.primary}`}>
                  Guardar cacería
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL: EDITAR CACERÍA */}
      {isEditOpen && caceriaToEdit && (
        <div className={styles["modal-overlay"]}>
          <div className={`${styles["modal-content"]} ${styles["modal-form"]}`}>
            <form onSubmit={handleSubmitEditCaceria}>
              <h3>Editar cacería</h3>

              <div className={styles.field}>
                <label className={styles.label}>Nombre (opcional)</label>
                <input
                  type="text"
                  name="nombre"
                  placeholder="Ej: Montería La Dehesa"
                  value={caceriaToEdit.nombre || ""}
                  onChange={handleEditCaceriaChange}
                />
              </div>

              <div className={styles["grid-2"]}>
                <div className={styles.field}>
                  <label className={styles.label}>Fecha</label>
                  <input type="date" name="fecha" value={caceriaToEdit.fecha} onChange={handleEditCaceriaChange} required />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Tipo de cacería</label>
                  <select name="tipoCaceria" value={caceriaToEdit.tipoCaceria} onChange={handleEditCaceriaChange} required>
                    {tipoCaceria.map((t) => {
                      const value = typeof t === "string" ? t : t.codigo ?? t.id ?? t.value ?? t.nombre;
                      const label = typeof t === "string" ? t : t.descripcion ?? t.nombre ?? t.label ?? value;
                      return <option key={value} value={value}>{label}</option>;
                    })}
                  </select>
                </div>
              </div>

              <div className={styles.field} style={{ marginTop: 20 }}>
                <label className={styles.label}>Documento (PDF/Imagen/Excel/CSV)</label>
                <input
                  type="file"
                  accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                  onChange={(e) => setFileEdit(e.target.files?.[0] ?? null)}
                />
                {caceriaToEdit.rutaDocumento && (
                  <div style={{ marginTop: 8 }}>
                    <a href={caceriaToEdit.rutaDocumento} target="_blank" rel="noreferrer">Ver documento actual</a>
                  </div>
                )}
              </div>

              <div className={styles.field} style={{ marginTop: 10 }}>
                <label className={styles.label}>Enlaces (OneDrive, SharePoint…)</label>
                {(caceriaToEdit.enlaces || []).map((url, i) => (
                  <div key={i} style={{ display: "flex", gap: 8, marginTop: 6 }}>
                    <input
                      type="url"
                      placeholder="https://..."
                      value={url}
                      onChange={(e) => handleEnlaceChangeEdit(i, e.target.value)}
                      style={{ flex: 1 }}
                    />
                    <button type="button" className={`${styles.btn} ${styles.danger}`} onClick={() => handleRemoveEnlaceEdit(i)}>
                      <IoTrashOutline />
                    </button>
                  </div>
                ))}
                <button type="button" className={styles.btn} style={{ marginTop: 8 }} onClick={handleAddEnlaceEdit}>
                  <IoAddOutline /> Añadir enlace
                </button>
              </div>

              <h4>Cazadores</h4>

              {(caceriaToEdit.participaciones || []).length === 0 && (
                <div className={`${styles.card} ${styles.soft}`}>Aún no hay participantes.</div>
              )}

              {(caceriaToEdit.participaciones || []).map((p, i) => {
                const personasFiltradas = personasFiltradasParaIndex(caceriaToEdit.participaciones, i);

                return (
                  <div key={p.id || `edit-${i}`} className={styles["item-card"]}>
                    <div className={styles["item-row"]}>
                      <div className={styles["grid-3"]}>
                        <div className={styles.field}>
                          <label className={styles.label}>Rol</label>
                          <select value={p.rol} onChange={(e) => handleParticipationChangeEdit(i, "rol", e.target.value)} required>
                            <option value="">Seleccione un rol</option>
                            {roles.map((r) => <option key={r.id} value={r.id}>{r.rol}</option>)}
                          </select>
                        </div>

                        <div className={styles.field}>
                          <label className={styles.label}>Persona</label>
                          <select value={p.persona} onChange={(e) => handleParticipationChangeEdit(i, "persona", e.target.value)} required>
                            <option value="">Seleccione una persona</option>
                            {personasFiltradas.map((pers) => (
                              <option key={pers.id} value={pers.id}>{pers.nombre} {pers.apellidos}</option>
                            ))}
                          </select>
                        </div>

                        <div className={styles.field}>
                          <label className={styles.label}>Arma 1</label>
                          <div className={styles.armaField}>
                            <ArmaSearchSelect
                              armas={armasIndex}
                              valueId={p.arma1 || ""}
                              onChange={(newId) => handleParticipationChangeEdit(i, "arma1", newId || "")}
                            />
                          </div>
                        </div>

                        <div className={styles.field}>
                          <label className={styles.label}>Arma 2</label>
                          <div className={styles.armaField}>
                            <ArmaSearchSelect
                              armas={armasIndex}
                              valueId={p.arma2 || ""}
                              onChange={(newId) => handleParticipationChangeEdit(i, "arma2", newId || "")}
                            />
                          </div>
                        </div>
                      </div>

                      {roles.find((r) => r.id === Number(p.rol))?.rol === "CAZADOR" && (
                        <div className={styles["grid-3"]}>
                          <div className={styles.field}>
                            <label className={styles.label}>Secretario</label>
                            <select
                              value={p.secretarioId ?? ""}
                              onChange={(e) => handleParticipationChangeEdit(i, "secretarioId", e.target.value ? Number(e.target.value) : null)}
                            >
                              <option value="">Selecciona secretario</option>
                              {personas.filter((per) => per.tipoPersona === "STAFF").map((per) => (
                                <option key={per.id} value={per.id}>{per.nombre} {per.apellidos}</option>
                              ))}
                            </select>
                          </div>

                          <div className={styles.field}>
                            <label className={styles.label}>Cargador</label>
                            <select
                              value={p.cargadorId ?? ""}
                              onChange={(e) => handleParticipationChangeEdit(i, "cargadorId", e.target.value ? Number(e.target.value) : null)}
                            >
                              <option value="">Selecciona cargador</option>
                              {personas.filter((per) => per.tipoPersona === "STAFF").map((per) => (
                                <option key={per.id} value={per.id}>{per.nombre} {per.apellidos}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}

                      <div className={styles["item-actions"]}>
                        <button type="button" className={`${styles.btn} ${styles.danger}`} onClick={() => handleRemoveParticipationFieldEdit(i)}>
                          <IoTrashOutline /> Eliminar participante
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}

              <div className={styles["item-actions"]}>
                <button type="button" className={styles.btn} onClick={handleAddParticipationFieldEdit}>
                  + Añadir participante
                </button>
              </div>

              <div className={styles["modal-actions"]}>
                <button className={`${styles.btn} ${styles.ghost}`} type="button" onClick={() => setIsEditOpen(false)}>
                  Cancelar
                </button>
                <button className={`${styles.btn} ${styles.primary}`} type="submit">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showDeleteConfirmation && caceriaToDelete && (
        <ConfirmDeleteModal
          title="Confirmar eliminación de cacería"
          message={`¿Eliminar la cacería del ${formatDate(caceriaToDelete.fecha)} (${caceriaToDelete.tipoCaceria})? Esta acción es irreversible.`}
          confirmWord="Eliminar"
          onConfirm={confirmDeleteCaceria}
          onClose={() => { }}
        />
      )}

      {infoModal.open && (
        <InfoModal
          title={infoModal.title}
          message={infoModal.message}
          onClose={() => setInfoModal({ open: false, title: "", message: "" })}
        />
      )}
    </div>
  );
}
